var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RankList"},[(_vm.ranks.length==0)?_c('div',{staticClass:"noitem"},[_vm._v("暂无排名")]):_vm._e(),_vm._l((_vm.ranks),function(r){return _c('item',{key:r.rank,attrs:{"item":r,"undo":_vm.undo}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }